module.exports = __webpack_public_path__ + "img/partner-list-1.2b72446c.png";